var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProperty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4133 21.6507H21.6496M11.4133 33.4505H21.6496M32.063 60H7.22439C3.80245 60 1 57.2565 1 53.8936V10.1164C1 2.38751 6.7524 -1.12293 13.8028 2.32851L26.9005 8.75939C29.7325 10.1459 32.063 13.8333 32.063 16.9603V60ZM59.999 39.5274V50.6782C59.999 57.0501 57.049 60 50.6771 60H32.063V25.8396L33.4494 26.1346L46.7242 29.114L52.7126 30.4415C56.6065 31.297 59.7925 33.303 59.9695 38.9669C59.999 39.1439 59.999 39.3209 59.999 39.5274V39.5274Z",
    stroke: "#4C3CA6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.725 29.1181V38.617C46.725 42.2749 43.7455 45.2543 40.0876 45.2543C36.4296 45.2543 33.4502 42.2749 33.4502 38.617V26.1387L46.725 29.1181ZM59.9702 38.9709C59.8805 40.6644 59.1457 42.2592 57.9168 43.4277C56.6879 44.5963 55.0581 45.2499 53.3623 45.2543C49.7044 45.2543 46.725 42.2749 46.725 38.617V29.1181L52.7134 30.4456C56.6073 31.3011 59.7932 33.307 59.9702 38.9709Z",
    stroke: "#4C3CA6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty);
export default __webpack_public_path__ + "static/media/property.fb955944ffa66ca50dd6431377091339.svg";
export { ForwardRef as ReactComponent };